import React from 'react';
import { Anchor, Globe2, Music2, Utensils } from 'lucide-react';
import SEO from '../../components/SEO';
import { SitePage, PageHero, SectionHead, CtaBand } from '../../components/site/ui';
import { inr, unsplash } from '../../components/site/brand';
import ServiceEnquiry from '../../components/site/ServiceEnquiry';

const CRUISES = [
  { title: 'Singapore & Malaysia', days: '4–5 nights', from: 75000, image: 'photo-1599640842225-85d111c60e6b', text: 'Round trips from Singapore calling at Penang, Phuket or Kuala Lumpur — the easiest first cruise.' },
  { title: 'Mediterranean', days: '7–12 nights', from: 250000, image: 'photo-1548574505-12caf0050b5b', text: 'Italy, Greece, Croatia and Turkey — combine with a Europe tour before or after.' },
  { title: 'Caribbean', days: '7–10 nights', from: 325000, image: 'photo-1559599746-8823b38544c6', text: 'Island hopping from Miami — beaches, snorkelling and big-ship entertainment.' },
];

const CruisePackages = () => (
  <SitePage>
    <SEO title="Cruise Holidays from India" description="Singapore, Mediterranean and Caribbean cruises with flights, visas and pre/post-cruise stays arranged by VK Tours." path="/travel-services/cruise" image={unsplash('photo-1575110445943-15b543686b56', 1200)} />
    <PageHero
      image={unsplash('photo-1575110445943-15b543686b56', 2000)}
      imageAlt="Cruise ship at sea"
      crumbs={[{ label: 'Home', to: '/' }, { label: 'Services' }, { label: 'Cruises' }]}
      kicker="Holidays at sea"
      title="Cruise"
      accent="holidays"
      lede="Several countries, one cabin to unpack in. We book the cruise, flights, visas and hotel nights before and after — all on one quote."
    >
      <a className="vk-btn vk-btn--hot" href="#enquire">Get a cruise quote</a>
      <a className="vk-btn vk-btn--ghost" href="#cruises">See popular cruises</a>
    </PageHero>

    <section className="vk-section vk-section--sand" id="cruises" style={{ scrollMarginTop: 'calc(var(--header-h) + 12px)' }}>
      <div className="vk-wrap">
        <SectionHead kicker="Popular sailings" title="Where to cruise" />
        <div className="vk-grid vk-grid--3">
          {CRUISES.map((c) => (
            <a key={c.title} className="vk-card" href="#enquire">
              <div className="vk-card__media"><img src={unsplash(c.image, 900)} alt={`${c.title} cruise`} loading="lazy" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} /></div>
              <div className="vk-card__body">
                <h3 className="vk-card__title">{c.title}</h3>
                <p className="vk-gdesc">{c.text}</p>
                <div className="vk-card__price">
                  <div><small>{c.days} · from</small><strong>{inr(c.from)}</strong><small>per person</small></div>
                  <span className="vk-btn vk-btn--dark vk-btn--sm">Enquire</span>
                </div>
              </div>
            </a>
          ))}
        </div>
        <p className="vk-form__note" style={{ marginTop: 16 }}>Indicative starting prices per person; final fares depend on ship, cabin and sailing date.</p>
      </div>
    </section>

    <section className="vk-section">
      <div className="vk-wrap">
        <SectionHead kicker="Why cruise" title="One trip, many places" />
        <div className="vk-feats">
          <div className="vk-feat"><Globe2 size={28} /><h3>Many destinations</h3><p>Wake up in a new port most mornings.</p></div>
          <div className="vk-feat"><Utensils size={28} /><h3>Meals included</h3><p>Several restaurants, with vegetarian options on board.</p></div>
          <div className="vk-feat"><Music2 size={28} /><h3>Entertainment</h3><p>Shows, pools, kids’ clubs and spas.</p></div>
          <div className="vk-feat"><Anchor size={28} /><h3>Fully arranged</h3><p>Flights, visas, transfers and hotel nights handled by us.</p></div>
        </div>
      </div>
    </section>

    <ServiceEnquiry
      title="Plan your cruise"
      productType="cruise"
      subject="Hi VK Tours, I'd like a cruise quote."
      fields={[
        { key: 'destination', label: 'Cruise region', options: ['Singapore & Malaysia', 'Mediterranean', 'Caribbean', 'Alaska', 'Dubai & Arabian Gulf', 'Other'], placeholder: 'Choose a region', required: true },
        { key: 'cabin', label: 'Cabin type', options: ['Interior', 'Ocean view', 'Balcony', 'Suite'], placeholder: 'Any' },
      ]}
      points={['Cruise fare, port taxes and gratuities shown clearly', 'Flights from your city and visas arranged', 'Hotel nights before and after the cruise']}
    />

    <CtaBand />
  </SitePage>
);

export default CruisePackages;
